import { render, staticRenderFns } from "./simpleComparePricesTable.vue?vue&type=template&id=8e6770c2&scoped=true"
import script from "./simpleComparePricesTable.vue?vue&type=script&lang=js"
export * from "./simpleComparePricesTable.vue?vue&type=script&lang=js"
import style0 from "./simpleComparePricesTable.vue?vue&type=style&index=0&id=8e6770c2&prod&scoped=true&lang=css"
import style1 from "./simpleComparePricesTable.vue?vue&type=style&index=1&id=8e6770c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6770c2",
  null
  
)

export default component.exports